import { createContext, useContext } from 'react';

export const InputsContext = createContext();

export const useInputs = () => useContext(InputsContext);
